<div class="mt-2 mb-3 d-flex row align-items-center">
    <!-- Container dos filtros: ocupa col-11 quando há tooltip, col-12 quando não há -->
    <div
        class="row align-items-center"
        [ngClass]="tooltipMensagem ? 'col-md-11' : 'col-md-12'">
        <ng-container *ngFor="let filtro of filtros">
            <div [ngClass]="getColClass(filtro)">
                <label
                    *ngIf="filtro.label"
                    class="form-control-label mb-0"
                    for="{{ filtro.id }}">
                    <!-- <small class="text-muted">{{ filtro.label }}</small> -->
                    {{ filtro.label }}
                </label>

                <!-- Select -->
                <select
                    *ngIf="filtro.tipo === 'select'"
                    class="form-control"
                    [formControl]="controles[filtro.id]">
                    <option value="">
                        {{ filtro.placeholder || filtro.label }}
                    </option>
                    <option
                        *ngFor="let opcao of getOpcoes(filtro)"
                        [value]="opcao">
                        {{ opcao }}
                    </option>
                </select>

                <!-- Text -->
                <input
                    *ngIf="filtro.tipo === 'text'"
                    type="text"
                    class="form-control"
                    [formControl]="controles[filtro.id]"
                    [placeholder]="filtro.placeholder || filtro.label" />

                <!-- Checkbox -->
                <div *ngIf="filtro.tipo === 'checkbox'" class="form-check mt-2">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        [formControl]="controles[filtro.id]"
                        [id]="'sume-filtro-' + filtro.id" />
                    <label
                        class="form-check-label"
                        [for]="'sume-filtro-' + filtro.id">
                        {{ filtro.label }}
                    </label>
                </div>

                <!-- Balão (pills com badge de contagem) -->
                <div *ngIf="filtro.tipo === 'balão'" class="scrollbar-x">
                    <div class="pt-1" style="width: 100%">
                        <!-- Pill "Tudo" -->
                        <button
                            type="button"
                            class="btn btn-sm border border-primary rounded-pill ml-1 mb-2"
                            [ngClass]="{
                                'btn-blue': controles[filtro.id].value === '',
                                'btn-light': controles[filtro.id].value !== ''
                            }"
                            [disabled]="controles[filtro.id].value === ''"
                            (click)="controles[filtro.id].setValue('')">
                            <div class="d-flex flex-row align-items-center">
                                Tudo
                                <span class="badge badge-info ml-1">{{
                                    getTudoCount()
                                }}</span>
                            </div>
                        </button>
                        <!-- Pill por opção -->
                        <button
                            type="button"
                            *ngFor="let item of getOpcoesBalaoBadge(filtro)"
                            class="btn btn-sm border border-primary rounded-pill ml-1 mb-2"
                            [ngClass]="{
                                'btn-blue':
                                    controles[filtro.id].value === item.opcao,
                                'btn-light':
                                    controles[filtro.id].value !== item.opcao
                            }"
                            [disabled]="
                                controles[filtro.id].value === item.opcao
                            "
                            (click)="controles[filtro.id].setValue(item.opcao)">
                            <div class="d-flex flex-row align-items-center">
                                {{ item.opcao }}
                                <span class="badge badge-info ml-1">{{
                                    item.count
                                }}</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Tooltip de ajuda (opcional) -->
    <div class="mr-auto px-0" *ngIf="tooltipMensagem">
        <sume-help-tooltip [message]="tooltipMensagem" placement="bottom">
        </sume-help-tooltip>
    </div>
</div>
